/**
 * Collection Landing scroll reveals — Framer whileInView parity
 * EASE: cubic-bezier(0.22, 1, 0.36, 1)
 *
 * Attributes on elements:
 *   data-cl-reveal            required (value may be "rule" for scaleX hairline)
 *   data-cl-reveal-y          translateY px (default 24)
 *   data-cl-reveal-dur        seconds (default 1.1)
 *   data-cl-reveal-delay      ms (default 0)
 *   data-cl-reveal-margin     Framer viewport margin, e.g. "-100px" (default -100px)
 */
(function () {
  'use strict';

  var SECTION_TYPES = [
    'collection-intro-new',
    'collection-showcase-new',
    'collection-at-a-glance-new',
    'collection-upsell-new',
    'collection-imprint-new',
  ];
  var instances = new WeakMap();

  function reducedMotion() {
    return (
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  function applyVars(el) {
    var y = el.getAttribute('data-cl-reveal-y');
    var dur = el.getAttribute('data-cl-reveal-dur');
    var delay = el.getAttribute('data-cl-reveal-delay');
    if (y != null && y !== '') el.style.setProperty('--cl-y', y + 'px');
    if (dur != null && dur !== '') el.style.setProperty('--cl-dur', dur + 's');
    if (delay != null && delay !== '') el.style.setProperty('--cl-delay', delay + 'ms');
  }

  function ClReveal(root) {
    this.root = root;
    this.observers = [];
    this.els = Array.prototype.slice.call(root.querySelectorAll('[data-cl-reveal]'));

    if (!this.els.length) return;

    if (reducedMotion() || typeof IntersectionObserver === 'undefined') {
      this.els.forEach(function (el) {
        el.classList.add('is-inview');
      });
      return;
    }

    this.els.forEach(applyVars);

    /* Group by margin so each Framer viewport.margin is respected */
    var groups = {};
    this.els.forEach(function (el) {
      var margin = el.getAttribute('data-cl-reveal-margin') || '-100px';
      if (!groups[margin]) groups[margin] = [];
      groups[margin].push(el);
    });

    var self = this;
    Object.keys(groups).forEach(function (margin) {
      self.observeGroup(groups[margin], margin);
    });
  }

  ClReveal.prototype.observeGroup = function (nodes, marginY) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-inview');
          observer.unobserve(entry.target);
        });
      },
      {
        root: null,
        rootMargin: marginY + ' 0px ' + marginY + ' 0px',
        threshold: 0,
      }
    );

    nodes.forEach(function (el) {
      observer.observe(el);
    });
    this.observers.push(observer);
  };

  ClReveal.prototype.destroy = function () {
    this.observers.forEach(function (o) {
      o.disconnect();
    });
    this.observers = [];
  };

  function findRoot(sectionEl) {
    if (!sectionEl) return null;
    var type = sectionEl.getAttribute && sectionEl.getAttribute('data-section-type');
    if (type && SECTION_TYPES.indexOf(type) !== -1) return sectionEl;
    if (!sectionEl.querySelector) return null;
    for (var i = 0; i < SECTION_TYPES.length; i++) {
      var found = sectionEl.querySelector('[data-section-type="' + SECTION_TYPES[i] + '"]');
      if (found) return found;
    }
    return null;
  }

  function initRoot(root) {
    if (!root || instances.has(root)) return;
    instances.set(root, new ClReveal(root));
  }

  function destroyRoot(root) {
    if (!root || !instances.has(root)) return;
    instances.get(root).destroy();
    instances.delete(root);
  }

  function initAll(scope) {
    SECTION_TYPES.forEach(function (type) {
      (scope || document)
        .querySelectorAll('[data-section-type="' + type + '"]')
        .forEach(initRoot);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });
  if (document.readyState !== 'loading') initAll(document);

  document.addEventListener('shopify:section:load', function (event) {
    var root = findRoot(event.target);
    if (!root) return;
    destroyRoot(root);
    initRoot(root);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = findRoot(event.target);
    if (root) destroyRoot(root);
  });
})();
